import { render, staticRenderFns } from "./VitySlides.vue?vue&type=template&id=7c558fc0"
import script from "./VitySlides.vue?vue&type=script&lang=js"
export * from "./VitySlides.vue?vue&type=script&lang=js"
import style0 from "./VitySlides.vue?vue&type=style&index=0&id=7c558fc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports